export enum AllowedStatus {
    Requested = 2,
    Unconfirmed = 3,
    Completed = 4,
    NoShow = 5,
    Deleted = 6,
    Paid = 8,
    ConfirmedByPhone = 9,
    ConfirmedByEmail = 10,
    ConfirmedByText = 11,
    ConfirmedByEmailText = 12,
  }